// import React, { useState } from 'react';
// import Chart from 'react-apexcharts';
// import { Box } from '@mui/material';

// const ProductGraph = ({ products, startDate, endDate, month, year }) => {
//   // Filter products with volume > 0
//   const filteredProducts = products.filter(p => (p.totalQuantityUsed || 0) > 0);
//   // Use filtered products for data
//   const categories = filteredProducts.map(p => p.consumeableProductName);
//   const productVolumes = filteredProducts.map(p => p.totalQuantityUsed || 0);
//   const productunit = filteredProducts.map(p => p.productUnit || 0)

//   const graphObject = {
//     options: {
//       chart: {
//         id: 'product-bar',
//       },
//       xaxis: {
//         categories: categories,
//         title: {
//           text: 'Products',
//           style: { fontSize: '14px', fontWeight: 'bold' },
//         },
//       },
//       yaxis: {
//         title: {
//           text: 'Volume (ml)',
//           style: { fontSize: '14px', fontWeight: 'bold' },
//         },
//       },
//       title: {
//         text: 'Product vs Volume (ml)',
//         align: 'center',
//         style: {
//           fontSize: '16px',
//           fontWeight: 'bold',
//           color: '#333',
//         },
//       },
//       plotOptions: {
//         bar: {
//           horizontal: false,
//           columnWidth: '50%',
//         },
//       },
//       colors: ['#FFB6C1'],
//       dataLabels: {
//         enabled: true,
//         formatter: (val) => `${val} ml`,
//         style: {
//           fontSize: '12px',
//           colors: ['#000'],
//         },
//       },
//     },
//     series: [
//       {
//         name: 'Volume',
//         data: productVolumes,
//       },
//     ],
//   };

//   return (
//     <Box sx={{ mb: 3 }}>
//       <Chart
//         options={graphObject.options}
//         series={graphObject.series}
//         type="bar"
//         width="100%"
//         height="300"
//       />
//     </Box>
//   );
// };

// export default ProductGraph;
import React, { useState } from 'react';
import Chart from 'react-apexcharts';
import { Box } from '@mui/material';

const ProductGraph = ({ products, startDate, endDate, month, year }) => {
  // Filter products with volume > 0
  const filteredProducts = products.filter(p => (p.totalQuantityUsed || 0) > 0);
  
  // Use filtered products for data
  const categories = filteredProducts.map(p => p.consumeableProductName);
  const productVolumes = filteredProducts.map(p => p.totalQuantityUsed || 0);
  const productUnits = filteredProducts.map(p => p.productUnit || 'ml');

  // Create custom dataLabels formatter to use the correct unit for each product
  const dataLabelsFormatter = function(val, opts) {
    const index = opts.dataPointIndex;
    const unit = productUnits[index] || 'ml';
    return `${val} ${unit}`;
  };

  const graphObject = {
    options: {
      chart: {
        id: 'product-bar',
      },
      xaxis: {
        categories: categories,
        title: {
          text: 'Products',
          style: { fontSize: '14px', fontWeight: 'bold' },
        },
      },
      yaxis: {
        title: {
          text: 'Volume',
          style: { fontSize: '14px', fontWeight: 'bold' },
        },
        labels: {
          formatter: function(val) {
            return val;
          }
        }
      },
      title: {
        text: 'Product Consumption',
        align: 'center',
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#333',
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '50%',
        },
      },
      colors: ['#FFB6C1'],
      dataLabels: {
        enabled: true,
        formatter: dataLabelsFormatter,
        style: {
          fontSize: '12px',
          colors: ['#000'],
        },
      },
      tooltip: {
        y: {
          formatter: function(val, opts) {
            const index = opts.dataPointIndex;
            const unit = productUnits[index] || 'ml';
            return `${val} ${unit}`;
          }
        }
      }
    },
    series: [
      {
        name: 'Volume',
        data: productVolumes,
      },
    ],
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Chart
        options={graphObject.options}
        series={graphObject.series}
        type="bar"
        width="100%"
        height="300"
      />
    </Box>
  );
};

export default ProductGraph;